import * as Yup from 'yup';

export const formValues = {
    onlineId:"",
    shopId:"",
     itemID:'',
     mcatId:"",
    subcatId:"",
    languageType:1,
    userId:'1000000000',
    brandName:'',
    mrp:null,
    price:null,
    unit:null,
    discription:"",
    validFrom:"",
    validTo:"",










    
}

export const formValues1 = {
   
    id:'1000000000',
    trsnNo:0,
    content:'',
    title:'',
    priority:1,
    languageType:1,
    Visible:'554644116461'
   


    
   
}


let patternTwoDigisAfterComma = /^\d+(\.\d{0,2})?$/;
const commonStringValidator = Yup
  .number()
  .positive()
  .test(
    "is-decimal",
    "The amount should be a decimal with maximum two digits after comma",
    (val: any) => {
      if (val != undefined) {
        return patternTwoDigisAfterComma.test(val);
      }
      return true;
    }
  )
  .min(2, "minimum 5")
 
  .required("Is required");

  const validationSchema = Yup.object({
    amount: commonStringValidator,
  });



export const validation = () => (
    
    Yup.object({
        
        brandName:Yup.string()
        .required('Sorry the title is required'),
         mcatId:Yup.string().required('Sorry the content is required'),
        unit:Yup.string().required('Sorry the content is required'),
        subcatId:Yup.string().required('Sorry the content is required'),
        itemID:Yup.string().required('Sorry the content is required'),
        shopId:Yup.string().required('Sorry the content is required'),
        mrp:commonStringValidator,
        price:commonStringValidator,
        content:Yup.string()
        .required('Sorry the content is required')
        .min(10,'That is it ? ...write some more')
        // validFrom:Yup.string()
        // .required('Sorry the content is required'),
        // validTo:Yup.string()
        // .required('Sorry the content is required')
        
        // languageType:Yup.string()
        // .label('District')
        // .required("This field is requried"),
        //  phNo:Yup.string()
        //     .length(10)
        //     .matches(/^[0-9]{10}/)
        //     .required()
        //     .label('phone number').required("This field is phone number"),
        //     distcId:Yup.string()
        //     .label('District')
        //     .required("This field is requried"),
        //     talukId:Yup.string()
        //     .label('Taluk')
        //     .required("This field is requried")
    })
)


export const validation1 = () => (
    
    Yup.object({
        
      
        content:Yup.string()
        .required('Sorry the content is required')
        .min(10,'That is it ? ...write some more'),
        // languageType:Yup.string()
        // .label('District')
        // .required("This field is requried"),
        //  phNo:Yup.string()
        //     .length(10)
        //     .matches(/^[0-9]{10}/)
        //     .required()
        //     .label('phone number').required("This field is phone number"),
        //     distcId:Yup.string()
        //     .label('District')
        //     .required("This field is requried"),
        //     talukId:Yup.string()
        //     .label('Taluk')
        //     .required("This field is requried")
    })
)

export const validationAdress = () => (
    
    Yup.object({
        
       
      
          line1:Yup.string()
        .required('This field is requried')
        .min(5,'That is it ? ...write some more'),
        line2:Yup.string()
        .required('This field is requried')
        .min(5,'That is it ? ...write some more'),
        area:Yup.string()
        .required('This field is requried')
        .min(5,'That is it ? ...write some more'),
       pincode:Yup.string()
            .length(6)
           .matches(/^[0-9]{6}/)
        .required()


    




       
    })
)

export const formAdress = {
   
    shopId:"",
    line1:'',
    trsnNo:null,
    line2:'',
    area:'',
    area2:'',
    districtID:1,
    talukID:1,
     region:1,
    priority:1,
    finalApproved:100000
    
    

    
}



           
//validation for contact info

            export const validationContInfo = () => (
    
                Yup.object({
                    
                    title:Yup.string()
                    .required('This field is requried')
                    .min(3,'That is it ? ...write some more'),
                    email: Yup.string()
                    .required('Sorry the email is required')
                    .email('This is not a valid email'),
                    mobileNo:Yup.string()
                        .length(10)
                       .matches(/^[0-9]{10}/)
                    .required(),
                     })
            )
            
        export const formContInfo = {
   
                shopId:"",
                trsnNo:null,
                title:'',
                mobileNo:null,
                email:"",
                priority:1,
                approved:100


                
            
                
            }


            //Validation for Shop Timming 
            export const validationTimming= () => (
    
                Yup.object({
                   
                     brkStatus:Yup.string()
                    .required('This field is requried')
                  ,
                    dayID:Yup.string() .required('This field is requried')
                 ,
                   
                    weekStatus:Yup.string()
                    .required('This field is requried')
                   ,
                    remark:Yup.string()
                    .required('This field is requried'),
                    
                   
                   
                   
                     })
            )


            export const formTimming = {
        //     shopId:'',
        //     dayID: 0,
        //    brkStatus: '',
        //     openStatus:'',
        //     timeStatus: 'HALF',
        //     weekStatus: '',
        //     approved: 100000,
        //     remark: '',
        //     status: ''

         
    shopId:"",
    dayID:'',
    brkStatus:'',
    openStatus:'',
    timeStatus: 'HALF',
    weekStatus: '',
    remark: '',
    openFrom: null,
    openTo:null,
    brkFrom: null,
     brkTo: null,
    status: '',
    approved:100000
            }


            
            // export const formTimming = {
            //     shopId:'',
            //     dayID: 0,
            //     openFrom: '',
            //     openTo: '',
            //     brkFrom: '',
            //     brkTo: '',
            //     brkStatus: '',
            //     openStatus:'',
            //     timeStatus: 'HALF',
            //     weekStatus: '',
            //     approved: 100000,
            //     remark: '',
            //     status: ''
            //     }